<template>
  <div>
    <CRow class="justify-content-between mb-3">
      <CCol col="auto">
        <CDropdown
          :togglerText="
            $t(
              'role.orders.manage.ddmp.detail.delivery.table.products.modifyBtn'
            )
          "
          color="primary"
          :disabled="!canView(PERMS.ORDERS_EDIT)"
        >
          <CDropdownItem @click="setDelivered()">{{
            $t(
              "role.orders.manage.ddmp.detail.delivery.table.products.table.actions.markAsDelivered"
            )
          }}</CDropdownItem>
          <CDropdownItem @click="setNotDelivered()">{{
            $t(
              "role.orders.manage.ddmp.detail.delivery.table.products.table.actions.markAsNonDelivered"
            )
          }}</CDropdownItem>
          <CDropdownItem @click="createIncident(INCIDENT_TYPE.INCIDENT)">{{
            $t("role.orders.manage.incident.modal.title.openIncident")
          }}</CDropdownItem>

          <CDropdownItem @click="createIncident(INCIDENT_TYPE.CANCELLATION)">{{
            $t(
              "role.orders.manage.ddmp.detail.delivery.table.products.table.actions.cancel"
            )
          }}</CDropdownItem>
        </CDropdown>
      </CCol>
      <CCol
        col="auto"
        class="d-flex flex-row justify-content-end align-items-center"
      >
        <CButton
          color="primary"
          @click="refreshTable"
          class="mr-2 border-0"
          variant="outline"
        >
          <font-awesome-icon icon="retweet" />
        </CButton>
        <CButton
          color="primary"
          @click="toggleAllRows"
          class="mr-2 border-0"
          variant="outline"
        >
          <font-awesome-icon icon="compress" />
        </CButton>
        <OrdersPrints
          :prints="ddmp.prints"
          :title="
            $t(
              'role.orders.manage.ddmp.detail.delivery.table.products.printBtn'
            )
          "
          :types="getProducerPrints"
        />
      </CCol>
    </CRow>

    <div class="d-flex justify-content-center m-3" v-if="loading">
      <CSpinner color="info" />
    </div>

    <ejs-grid
      v-show="!loading"
      ref="grid"
      :dataSource="rows"
      :allowSelection="true"
      :selectionSettings="selectionSettings"
      :detailTemplate="detailTemplate"
      :dataBound="onDataBound"
      @rowSelected="rowSelectedHandler($event)"
      @rowDeselected="rowDeselectedHandler($event)"
      @detailDataBound="onDetailDataBound"
    >
      <e-columns>
        <e-column type="checkbox" width="40" textAlign="left"></e-column>
        <e-column
          isPrimaryKey="{true}"
          field="id"
          :headerText="$t('role.orders.rounds.ddmi.details.table.account')"
          width="70"
          :template="accountTemplate"
        ></e-column>
        <e-column
          field="order.order.id"
          :headerText="$t('role.orders.manage.ddmp.detail.orders.table.name')"
          :template="nameTemplate"
          width="600"
        ></e-column>
        <e-column
          field="order.order.ts_created"
          :headerText="$t('role.orders.manage.ddmp.detail.orders.table.time')"
          :template="dateTemplate"
          width="150"
        ></e-column>
        <e-column
          field="info"
          :headerText="$t('role.orders.manage.ddmp.detail.orders.table.info')"
          :template="infoTemplate"
        ></e-column>
        <e-column
          field="price"
          :headerText="$t('role.orders.manage.ddmp.detail.orders.table.price')"
          textAlign="right"
          :template="priceTemplate"
          width="150"
        ></e-column>
        <e-column
          field="action"
          headerText=""
          width="80"
          :template="actionsTemplate"
        ></e-column>
      </e-columns>
    </ejs-grid>

    <CModal :show="AddModalShow" :closeOnBackdrop="false" :centered="true">
      <template v-if="AddModalOrder" #header>
        <h5 class="modal-title">
          {{ $t("role.orders.manage.addProductModal.title") }} #{{
            AddModalOrder.order.id
          }}<br />{{ AddModalOrder.order.family.name }}
        </h5>
      </template>
      <div>
        <CAlert
          v-if="AddFormError.hasGeneralErrors()"
          color="danger"
          class="mb-3"
        >
          {{ AddFormError.general().join(" ") }}
        </CAlert>
        <div class="form-group">
          <label>{{
            $t("role.orders.manage.addProductModal.searchProduct")
          }}</label>
          <v-select
            class="bg-white"
            label="label"
            v-model="AddForm.ppm"
            :options="AddFormPpmSearchOptions"
            @search="AddFormPpmSearchFetch"
          />
          <div
            v-if="AddFormError.hasFieldsError('ppm')"
            class="invalid-feedback d-block"
          >
            {{ AddFormError.fieldError("ppm") }}
          </div>
        </div>
        <div class="form-group">
          <label v-if="addFormPw">{{
            $t("role.orders.manage.addProductModal.weight")
          }}</label>
          <label v-else>{{
            $t("role.orders.manage.addProductModal.amount")
          }}</label>
          <CInput v-model="AddForm.qta" class="mb-0 mr-1" type="number" min="0">
          </CInput>
          <div
            v-if="AddFormError.hasFieldsError('qta')"
            class="invalid-feedback d-block"
          >
            {{ AddFormError.fieldError("qta") }}
          </div>
        </div>

        <div class="form-group">
          <label>{{
            $t("role.orders.manage.addProductModal.unitPrice")
          }}</label>
          <CInput
            class="mb-0 mr-1"
            v-model="AddForm.price"
            type="number"
            min="0"
          />
          <div
            v-if="AddFormError.hasFieldsError('price')"
            class="invalid-feedback d-block"
          >
            {{ AddFormError.fieldError("price") }}
          </div>
        </div>

        <div class="form-group">
          <label
            >{{ $t("role.orders.manage.addProductModal.total") }}
            {{ AddForm.tot_price_family }} CHF</label
          ><br />
          <label
            >{{ $t("role.orders.manage.addProductModal.total_prod") }}
            {{ AddForm.tot_price }} CHF</label
          >
        </div>
      </div>
      <template #footer>
        <CButton
          color="primary"
          variant="outline"
          @click.prevent="AddModalClose"
          >{{ $t("role.orders.manage.addProductModal.btnCancel") }}</CButton
        >
        <vue-ladda
          v-if="addFormEnableSubmit"
          :loading="loading"
          data-style="zoom-in"
          button-class="btn btn-primary px-4"
          @click.prevent="addFormOnSubmit"
          >{{
            $t("role.orders.manage.addProductModal.btnAddProduct")
          }}</vue-ladda
        >
      </template>
    </CModal>

    <OrderTableBoxesModal
      v-if="BoxesModalShow"
      :order="BoxesModalOrder"
      :loading="loading"
      @close="BoxesModalClose"
      @submit="onBoxesFormSubmit"
    />
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import { DetailRow } from "@syncfusion/ej2-vue-grids";
import { Query, Predicate } from "@syncfusion/ej2-data";
import { GetDataManagerNew } from "../../../../../../ds";
import OrdersTableAccount from "./OrdersTableAccount";
import OrdersTableName from "./OrdersTableName";
import OrdersTableDate from "./OrdersTableDate";
import OrdersTableInfo from "./OrdersTableInfo";
import OrdersTablePrice from "./OrdersTablePrice";
import OrdersTableActions from "./OrdersTableActions";
import OrdersTableRowDetails from "./OrdersTableRowDetails";
import OrderTableBoxesModal from "./OrderTableBoxesModal";
import EventBus from "../../../../../../helpers/EventBus";
import { buildPredicate } from "../../../../../../helpers/common";
import orderManagementMixin from "../../../share/mixin";
import { filtersMap } from "../../filtersMap";
import { PERMS } from "../../../../../../helpers/acl";
import OrdersPrints from "../../../share/OrdersPrints";
import { INCIDENT_TYPE } from "../../../../../../config/global";
import errorResponse from "../../../../../../helpers/error";
import { getAddFormPpmSearchOptions } from "../../../../../../helpers/options";
import vSelect from "vue-select";
import debounce from "lodash/debounce";

export default {
  name: "OrdersTable",

  components: {
    OrdersPrints,
    vSelect,
    OrderTableBoxesModal,
  },

  mixins: [orderManagementMixin],

  props: {
    ddmp: { type: Object, required: true },
  },

  provide: {
    grid: [DetailRow],
  },

  watch: {
    ddmp() {
      this.itemSelected = Object.assign({});
      this.loadData();
    },
    addFormPpm() {
      this.AddForm.qta = 0;
      if (this.AddForm.ppm) {
        this.AddForm.price = this.AddForm.ppm.value.ppl.price;
      } else {
        this.AddForm.price = null;
      }
      this.AddForm.tot_price = 0;
      this.AddForm.tot_price_family = 0;
      // this.AddForm.tot_price = this.AddForm.price * this.AddForm.qta
    },
    addFormQta() {
      this.AddForm.tot_price = this.AddForm.price * this.AddForm.qta;
      this.AddForm.tot_price_family =
        this.AddForm.ppm.value.ppm.price -
        this.AddForm.ppm.value.ppl.price +
        this.AddForm.price * this.AddForm.qta;
    },
    addFormPrice() {
      this.AddForm.tot_price = this.AddForm.price * this.AddForm.qta;
      this.AddForm.tot_price_family =
        this.AddForm.ppm.value.ppm.price -
        this.AddForm.ppm.value.ppl.price +
        this.AddForm.price * this.AddForm.qta;
    },
  },

  computed: {
    addFormPpm() {
      if (this.AddForm.ppm) {
        return this.AddForm.ppm.value.ppm.id;
      }
      return null;
    },
    addFormQta() {
      if (this.AddForm.qta) {
        return this.AddForm.qta;
      }
      return null;
    },
    addFormPrice() {
      if (this.AddForm.price) {
        return this.AddForm.price;
      }
      return null;
    },
    addFormPw() {
      if (this.AddForm.ppm) {
        return this.AddForm.ppm.value.ppm.pw;
      }
      return false;
    },
    addFormEnableSubmit() {
      if (this.AddForm.tot_price > 0) {
        return true;
      }
      return false;
    },
    getProducerPrints() {
      var res = ["producer_orders"];
      // , 'producer_orders_direct'
      if (this.ddmp.ddmp.delivery_type == 3) {
        res.push("producer_orders_direct");
      }
      return res;
    },
  },

  data: function () {
    const roleId = this.$store.state.role.id;
    const endpoint = filtersMap("ddmp.panel2.list.endpoint");
    const dm = GetDataManagerNew(endpoint, [roleId]);

    return {
      INCIDENT_TYPE,
      PERMS,
      dm: dm,
      loading: false,
      rows: [],
      allRowsExpanded: false,
      AddModalShow: false,
      AddModalOrder: null,
      BoxesModalShow: false,
      BoxesModalOrder: null,
      AddForm: {
        ppm: null,
        qta: 0,
        price: null,
        tot_price: null,
        tot_price_family: null,
      },
      AddFormError: errorResponse(),
      AddFormPpmSearchOptions: [],
      selectionSettings: {
        persistSelection: false,
        enableToggle: true,
        checkboxOnly: true,
      },

      itemSelected: {},

      accountTemplate: () => {
        return { template: OrdersTableAccount };
      },

      nameTemplate: () => {
        return { template: OrdersTableName };
      },

      dateTemplate: () => {
        return { template: OrdersTableDate };
      },

      infoTemplate: () => {
        return { template: OrdersTableInfo };
      },

      priceTemplate: () => {
        return { template: OrdersTablePrice };
      },

      actionsTemplate: () => {
        return { template: OrdersTableActions };
      },

      detailTemplate: () => {
        return {
          template: {
            extends: OrdersTableRowDetails,
            propsData: {
              grid: this.$refs.grid,
              ddmp: this.ddmp,
            },
          },
        };
      },
    };
  },

  mounted() {
    EventBus.$on("orders:detail", this.onDetailsSelected);
    EventBus.$on("orders:priceUpdate", this.onDetailPriceUpdate);
    EventBus.$on("orders:addnew", (order) => {
      this.AddModalShow = true;
      this.AddModalOrder = order;
    });
    EventBus.$on("orders:addBoxes", (order) => {
      this.BoxesModalShow = true;
      this.BoxesModalOrder = order;
    });
    this.loadData();
  },

  beforeDestroy() {
    EventBus.$off("orders:detail", this.onDetailsSelected);
    EventBus.$off("orders:priceUpdate", this.onDetailPriceUpdate);
    EventBus.$off("orders:addnew");
    EventBus.$off("orders:addBoxes");
  },

  methods: {
    toggleAllRows() {
      const grid = this.$refs.grid;
      if (!grid) return;
      if (this.allRowsExpanded) {
        grid.ej2Instances.detailRowModule.collapseAll();
        this.allRowsExpanded = false;
      } else {
        grid.ej2Instances.detailRowModule.expandAll();
        this.allRowsExpanded = true;
      }
    },

    refreshTable() {
      this.$refs.grid.ej2Instances.refresh();
    },

    AddModalClose() {
      this.AddModalShow = false;
      this.AddModalOrder = null;
    },

    BoxesModalClose() {
      this.BoxesModalShow = false;
      this.BoxesModalOrder = null;
    },

    onBoxesFormSubmit(requestParams) {
      this.loading = true;
      this.loading = false;
    },

    getAddFormPpmSearchOptions: debounce(
      (search, producer_id, market_id, loading, vm) => {
        getAddFormPpmSearchOptions({ search, producer_id, market_id }).then(
          (options) => {
            loading(false);
            vm.AddFormPpmSearchOptions = [...options];
          }
        );
      },
      350
    ),

    AddFormPpmSearchFetch(search, loading) {
      if (search.length) {
        loading(true);
        // console.log(this.AddModalOrder)
        this.getAddFormPpmSearchOptions(
          search,
          this.$store.state.role.id,
          this.AddModalOrder.order.market,
          loading,
          this
        );
      }
    },

    loadData() {
      const query = this.prepareQuery();
      this.loading = true;

      this.dm
        .executeQuery(query)
        .then((response) => {
          this.loading = false;

          // Sort by order.ts_created with newest first
          const sortedResult = response.result.sort((a, b) => {
            const dateA = new Date(a.order.order.ts_created);
            const dateB = new Date(b.order.order.ts_created);
            return dateB - dateA; // Descending order (newest first)
          });
          this.rows = sortedResult;
        })
        .catch((response) => {
          this.loading = false;
          console.error(response);
        });
    },

    prepareQuery() {
      const { keyword } = this.$store.state.orders.filters;
      let predicate = new Predicate("ddmp", "equal", this.ddmp.ddmp.id);

      const map = filtersMap("ddmp.panel2.list.filters");
      predicate = buildPredicate(
        predicate,
        map,
        this.$store.state.orders.filters
      );

      let query = new Query().where(predicate);

      const searchFields = filtersMap("ddmp.panel2.list.search", []);
      if (keyword && searchFields.length > 0) {
        query = query.search(keyword, searchFields);
      }

      return query;
    },

    getSelectedParentKey() {
      return "porders";
    },

    getSelectedChildrenKey() {
      return "details";
    },

    createIncident(type) {
      const selected = this.getSelected();
      if (selected) {
        const entities = [];
        Object.keys(selected).forEach((type) => {
          entities.push({ type, items: [...selected[type]] });
        });

        this.$store.commit("incidents/createResetAllEntities");
        this.$store.commit("incidents/createAddEntities", {
          type: type,
          entities,
          show: true,
        });
      }
    },

    setDelivered() {
      const selected = this.getSelected();
      if (selected) {
        let next_status = filtersMap("ddmp.statusCode.next");
        if (this.ddmp.ddmp.delivery_type == 3) {
          next_status = filtersMap("ddmiIsland.statusCode.next");
        }
        this.$store
          .dispatch("rounds/updateStatusBatch", {
            status: next_status,
            ...this.mapSelectedToIds(selected),
          })
          .then(this.onUpdateStatusSuccess);
      }
    },

    setNotDelivered() {
      const selected = this.getSelected();
      if (selected) {
        this.$store
          .dispatch("rounds/updateStatusBatch", {
            status: filtersMap("ddmp.statusCode.prev"),
            ...this.mapSelectedToIds(selected),
          })
          .then(this.onUpdateStatusSuccess);
      }
    },

    print() {},

    canView(perm) {
      return this.$store.getters["connections/havePermission"](perm);
    },
    addFormOnSubmit() {
      // console.log(this.AddForm)
      this.loading = true;
      this.AddFormError.reset();
      const producer_id = this.$store.state.role.id;
      const market_id = this.AddModalOrder.order.market;
      // const familyId = this.familyId;
      // const marketId = this.market.market.id;
      // this.loading=true
      // const requestParams = {
      //   ...this.prepareRequestParams(this.form),
      // };
      // // console.log(requestParams)
      // this.error.reset();
      const requestParams = {
        ppm: this.AddForm.ppm.value.ppm.id,
        qta: this.AddForm.qta,
        order: this.AddModalOrder.order.id,
        f_price: this.AddForm.price,
      };
      const dm = GetDataManagerNew("role_producer_orders_add_products", [
        producer_id,
        market_id,
      ]);
      dm.insert(requestParams)
        .then(() => {
          this.$store.dispatch("toaster/add", {
            title: "OK!",
            text: this.$t("role.products.create.create.confirm.q"),
            color: "success",
            autohide: true,
          });
          // //this.loading=false
          // // this.closeModal();
          // // EventBus.$emit("address:refresh");
          // //this.$store.commit("shop/setMarket", market);
          // this.$store.commit("shop/setCart", {});
          // this.$router.push({
          //   name: "RoleOrdersNew",
          //   params: { id: this.$store.state.role.id },
          // });
          this.loading = false;
          this.AddModalClose();
          this.onUpdateStatusSuccess();
        })
        .catch((response) => {
          const body = JSON.parse(response[0].error.response);
          this.AddFormError.set(body.errors);
          this.loading = false;
        });
    },
  },
};
</script>
